import getDocumentHeight from "./getDocumentHeight"

const getPageThreshold = (maxTriangles: number, footerHeight: number): number =>
  (getDocumentHeight() - window.innerHeight - footerHeight) / (maxTriangles + 1)

export default getPageThreshold
